import React, { Component } from 'react'
import './Table.css'
import { getImg } from '../../service/index'
import { connect } from 'react-redux'

class AttendessTable extends Component {

    static defaultProps = {
        handleAddUser: () => null,
        handleRemoveUser: () => null
    }

    constructor(props) {
        super(props)

        this.state = {
            currentTen: 0,

        }
    }


    render() {

        const { selectedPerson, handleAddUser, handleRemoveUser, marginTop, tableMode, } = this.props
        const { currentTen } = this.state
        const { token } = this.props.login.user
        return (
            <div className='title-user-table' style={{ marginTop, display: 'flex', flexDirection: 'column' }} >
                <div className={tableMode === 0 ? "user-table-container" : tableMode === 1 ? "user-table-container2" : 'user-table-container3'}>
                    {
                        selectedPerson.filter(ev => ev.status !== 1).map((el, i) => {
                            return i >= 10 * currentTen && i <= 9 + (10 * currentTen) ? <UserTableObj
                                key={el.hasOwnProperty('user_id') ? el.user_id : el.id}
                                {...el}
                                id={el.hasOwnProperty('user_id') ? el.user_id : el.id}
                                mode={tableMode === 0 || tableMode === 2 ? 0 : el.selected ? 2 : 1}
                                handleAddUser={handleAddUser}
                                handleRemoveUser={handleRemoveUser}
                                isOdd={i % 2 === 0 ? true : false}
                                index={i}
                                token={token}
                            /> : null
                        })
                    }
                </div>
                <div className='next-prev-user' style={{ display: 'flex', justifyContent: 'space-between', paddingRight: 14, marginTop: 20 }} >
                    <a onClick={this.handleSelectState(-1)} >ก่อนหน้า</a>
                    <p>{(this.state.currentTen + (selectedPerson.length > 0 ? 1 : 0)) + ' /' + Math.ceil(selectedPerson.length / 10) + ' หน้า'}</p>
                    <a onClick={this.handleSelectState(+1)}>ต่อไป</a> </div>

            </div>

        )
    }

    handleSelectState = (value) => () =>

        this.setState(prevState => ({
            currentTen: prevState.currentTen + value >= 0 && prevState.currentTen + value < Math.ceil(this.props.selectedPerson.length / 10) ? prevState.currentTen + value : prevState.currentTen
        }))
}

class UserTableObj extends Component {

    constructor(props) {
        super(props)

        this.state = {
            avatar: null
        }
    }


    componentDidMount = async () => {
        try {
            const token = this.props.token
            const avatar = await getImg('/image/' + (this.props.hasOwnProperty('user_id') ? this.props.user_id : this.props.id) + '.png', token)
            this.setState({ avatar })
        } catch (err) {

        }
    }


    render() {
        const { isOdd, mode, name, last_name, phone, id, user_department, handleRemoveUser, handleAddUser, index } = this.props
        const { avatar } = this.state
        return (
            <div className={isOdd ? "user-obj odd" : "user-obj"} >
                <img
                    className="user-avatar"
                    src={avatar ? avatar : "https://cdn3.iconfinder.com/data/icons/avatars-15/64/_Ninja-2-256.png"}
                    alt="avatar"
                />
                <div className="name-phone-container">
                    {name + " " + last_name}
                    <p className="user-phone">{phone}</p>
                </div>
                {mode === 0 ? (
                    <img
                        className="delete-user-row"
                        src={require("../../assets/icon/cancel.png")}
                        alt="cancel"
                        onClick={handleRemoveUser(id)}
                    />
                ) : mode === 1 ? (
                    <img
                        className="select-user-row-add"
                        src={require("../../assets/icon/add.png")}
                        alt="add"
                        onClick={handleAddUser({ name, last_name, phone, id, }, index)} // (user obj, index) : index เพื่อใช้ในการ
                    />
                ) : (
                            <img
                                className="select-user-row"
                                src={require("../../assets/icon/correct.png")}
                                alt="correct"
                                onClick={handleRemoveUser(id)}
                            />
                        )}
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    login: state.login
})

export default connect(mapStateToProps)(AttendessTable)


// WEBPACK FOOTER //
// ./src/components/Table/AttendessTable.js